import * as React from "react";
import { Device, StudyScheduleSession } from "webportalclient";
import { Subject } from "../../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";
import LoadingWithMessage from "../../../misc/components/LoadingWithMessage";
import { ConfigureDiaryDeployments } from "../P230In2itiveEDiary/ConfigurationHelpers";
import { ConfigureP230HomeSpirometrySession } from "./P230HomeSpirometryConfiguration";

interface P230HomeSpirometryRemoteConfigureProps {
    subject: Subject;
    remoteDeviceSelected: Device;
    sessionScheduleItems: StudyScheduleSession[];
    onComplete: (redirect?: string) => void;
}

export const P230HomeSpirometryRemoteConfigure = ({ subject, remoteDeviceSelected, sessionScheduleItems, onComplete }: P230HomeSpirometryRemoteConfigureProps) => {
    const client = useWebPortalApiClient();

    React.useEffect(() => {
        const remoteConfigure = async () => {
            await ConfigureDiaryDeployments(client.client, subject.Id, sessionScheduleItems, remoteDeviceSelected.serialNumber);

            const actions = await client.client.getStudyScheduleSessionActions(`actionType,studyScheduleSessionId`, `studyScheduleSessionId eq ${sessionScheduleItems[0].id}`);

            const createSession = actions.value.map(a => a.actionType).includes(6); // Supervised Home Spirometry

            const analysisSetResult = await ConfigureP230HomeSpirometrySession(client.client, remoteDeviceSelected.serialNumber, subject, sessionScheduleItems[0], createSession);

            if (createSession) {  
                onComplete(`/spirometry/siteAnalysis/${analysisSetResult.id}/edit`);
            } else {
                onComplete();
            }
        }

        remoteConfigure();
    }, []);

    return (
        <div className="modal-body">
            <LoadingWithMessage message="Starting Home Spirometry session..." />
        </div>
    );
}
